import { convert_excel_serial_number_to_date } from "../../../../../redux/po_backlog/utils/backlog_utils";
import { po_columns } from "./po_columns";

export default function PO_DATA(object) {
  const object_keys = Object.keys(po_columns).map(key => key.split(" ").join("_").toLowerCase());
  for (let key of object_keys) {
    // console.log(po_columns[key], key, po_columns);
    if (po_columns[key].type === "number") {
      this[key] = +object[key] || null;
    }
    else if (po_columns[key].type === "date" && typeof object[key] === "number") {
      // console.log({ type: "number", bro: po_columns[key], key });
      this[key] = convert_excel_serial_number_to_date(object[key]) || null;
    }
    else {
      this[key] = object[key] || null;
    }
  }
  let x = this;
  console.log({ object, object_keys, x });
  // console.log({ object, object_keys });
};